//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import Check from '@/common/utils/check'
import { resetToken } from '@/common/utils/ajax'
import { App_User } from '@/data/user_info'
import TASK_LIST from '@/data/unhandle_task'

let task = 0
export default {
    data() {
        return {
            mobile: '',
            sms_captcha: '',
            text: '获取验证码',
            time: 59,
            wait_time: false,
            focus_sms: false,
            is_success: false
        }
    },
    beforeDestroy () {
        task && clearTimeout(task)
        if (!this.is_success) {
            TASK_LIST.clearTask()
        }
    },
    computed: {
        checkMobile() {
            return Check.checkMobile(this.mobile)
        }
    },
    methods: {
        clearInput () {
            this.mobile = ''
        },
        getSms() {
            Service.getSmsCaptcha(this.mobile).then((res) => {
                this.wait_time = true
                this.changeTime()
            })
        },
        changeTime() {
            task = setTimeout(() => {
                this.time--
                if (this.time <= 0) {
                    this.text = '获取验证码'
                    this.wait_time = false
                    this.time = 59
                    clearTimeout(task)
                } else {
                    this.text = `${this.time}s后重新发送`
                    this.changeTime()
                }
            }, 1000)
        },
        onLogging() {
            Service.logging_in({
                mobile: this.mobile,
                sms_captcha: this.sms_captcha
            }).then((res) => {
                console.error('res', res)
                if (res.code === 401 || res.code === 422) {
                    wx.showToast({
                        title: '验证码不正确，请重新输入'
                    })
                } else {
                    resetToken(res.token)
                    App_User.fetchUser().then(this.success)
                }
            })
        },
        success () {
            this.$sendCtmEvtLog('注册并登录')
            this.is_success = true
            TASK_LIST.handleTask()
            this.$router.back()
        }
    }
}
